import { render, staticRenderFns } from "./quotations.vue?vue&type=template&id=e61c84ee"
import script from "./quotations.vue?vue&type=script&lang=js"
export * from "./quotations.vue?vue&type=script&lang=js"
import style0 from "./quotations.vue?vue&type=style&index=0&id=e61c84ee&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports